export const environment = {
    production: true,
    apiRoot: "http://apis.khidmatcharitabletrust.com/",
    filePath: "Files/Images/",
    clientName: "Khidmat Charitable Trust"
};
